// generateId available from ../utils/helpers if needed
import { HASH_123, DEFAULT_SALT } from "../utils/crypto";

export function createSeedData() {

  const companies = [
    { company_id: "c1", name: "AMETAL AFRICA", code: "AMETAL", logo_text: "AM", color: "#0ea5e9", plan: "Enterprise", users_limit: 50 },
  ];

  const users = [
    { user_id: "u1", name: "Ahmed Hassan", email: "ahmed@ametal.com", role: "CEO", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "u_coo", name: "Volkan Tegen", email: "volkan@ametal.com", role: "COO", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "u2", name: "Omar Farouk", email: "omar@ametal.com", role: "PM", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "u3", name: "Fatima Ali", email: "fatima@ametal.com", role: "Procurement", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "u4", name: "Ibrahim Musa", email: "ibrahim@ametal.com", role: "Warehouse", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "u5", name: "Amina Yusuf", email: "amina@ametal.com", role: "Finance", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "u6", name: "Khalid Osman", email: "khalid@ametal.com", role: "DataEntry", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "pm_p2", name: "Karim Mansour", email: "karim@ametal.com", role: "PM", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "pm_p3", name: "Nadia El-Amin", email: "nadia@ametal.com", role: "PM", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "u_hr", name: "Layla Mahmoud", email: "layla@ametal.com", role: "HR", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "sv_p1", name: "Mustafa Saleh", email: "mustafa@ametal.com", role: "Supervisor", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "sv_p2", name: "Youssef Bakr", email: "youssef@ametal.com", role: "Supervisor", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
    { user_id: "sv_p3", name: "Tariq Nasser", email: "tariq@ametal.com", role: "Supervisor", salt: DEFAULT_SALT, hashed_password: HASH_123, company_id: "c1", assigned_project_ids: [], is_active: true, last_login: null },
  ];

  const clients = [];
  const items = [];
  const vendors = [];
  const employees = [];
  const projects = [];
  const warehouses = [];
  const boqItems = [];
  const tasks = [];
  const purchaseOrders = [];
  const poLineItems = [];
  const materialDeliveries = [];
  const vendorInvoices = [];
  const vendorPayments = [];
  const salaryCharges = [];
  const otherExpenses = [];
  const overheadCosts = [];
  const clientInvoices = [];
  const clientPayments = [];
  const variations = [];
  const subContracts = [];
  const subClaims = [];
  const subBackCharges = [];
  const subPerformanceRatings = [];
  const clientDisputes = [];
  const retentionReleases = [];
  const equipment = [];
  const equipmentAssignments = [];
  const warehouseTransactions = [];
  const dailyLogs = [];
  const dailyLogTaskProgress = [];
  const laborUsage = [];
  const equipmentUsage = [];
  const costEstimates = [];
  const drawings = [];
  const rfis = [];
  const submittals = [];
  const correspondence = [];
  const safetyIncidents = [];
  const inspectionChecklists = [];
  const ncrs = [];
  const permitToWork = [];
  const delayEvents = [];
  const fuelConsumption = [];
  const maintenanceLogs = [];
  const equipmentRentalCharges = [];
  const documents = [];
  const auditLog = [];
  const companyAccounts = [];
  const accountTransactions = [];
  const notifications = [];
  const todos = [];
  const sitePhotos = [];

  // ── New Modules ──
  const tenders = [];
  const tenderItems = [];
  const contracts = [];
  const contractMilestones = [];
  const subcontractorProfiles = [];
  const timesheets = [];
  const timesheetLines = [];
  const attendanceRecords = [];
  const mtoRecords = [];
  const itpRecords = [];
  const punchListItems = [];
  const userNotes = [];
  const quotations = [];
  const datasheets = [];
  const otherDocs = [];
  const workPermitDocs = [];
  const qcReportDocs = [];
  const meetings = [];
  const actionItems = [];

  return {
    companies, users, clients, projects, warehouses, items, vendors, employees,
    boqItems, tasks, purchaseOrders, poLineItems, materialDeliveries,
    vendorInvoices, vendorPayments, salaryCharges, otherExpenses,
    warehouseTransactions, dailyLogs, dailyLogTaskProgress,
    documents, auditLog, clientPayments, variations, costEstimates, overheadCosts,
    subContracts, subClaims, subBackCharges, subPerformanceRatings,
    clientInvoices, clientDisputes, retentionReleases,
    drawings, rfis, submittals, correspondence,
    safetyIncidents, inspectionChecklists, ncrs, permitToWork,
    delayEvents, fuelConsumption, maintenanceLogs, equipmentRentalCharges,
    equipment, equipmentAssignments, equipmentUsage, laborUsage,
    companyAccounts, accountTransactions, sitePhotos,
    notifications, todos,
    tenders, tenderItems, contracts, contractMilestones,
    subcontractorProfiles, timesheets, timesheetLines, attendanceRecords,
    mtoRecords, itpRecords, punchListItems,
    userNotes, quotations, datasheets, otherDocs,
    workPermitDocs, qcReportDocs,
    meetings, actionItems,
    deliveryNotes: [],
  };
}
